import React, { useCallback, useEffect, useState } from 'react';
import { oauth, getImageSrc } from '../../../utils';
import { useSelector } from 'react-redux';

export const MarketingPanel = () => {
    const [marketingAdImage, setMarketingAdImage] = useState(null);
    const [marketingAdLink, setMarketingAdLink] = useState("");
    const blog = useSelector((state: any) => state.temp.blog);

    const getMarketingAd = useCallback(async () => {
        try {
          const resp = await oauth("GET", "marketing-setting/get", {
            loginpage_ad_settings: true,
            audience: null,
          });
          const ad = resp.json.settings[0];
          setMarketingAdImage(getImageSrc(ad.file_data, "original"));
          setMarketingAdLink(ad.link);
        } catch (e) {
          console.error("No marketing ad");
        }
    }, []);

    useEffect(() => {
        getMarketingAd();
    }, [getMarketingAd]);

    return (
        <div className="right-side-content">
        <div className="sideContent contentBoxContainer">
          <div className="topBox">
            <a href={marketingAdLink} target="_blank" rel="noreferrer">
              <div
                style={{
                  position: "relative",
                  minHeight: "300px",
                  height: "100%",
                  backgroundImage: `url(${marketingAdImage})`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center center",
                  backgroundSize: "cover",
                }}
              >
                <img
                  src="/images/xtrnl.svg"
                  style={{ float: "right", margin: "20px", width: "25px" }}
                  alt="external link"
                ></img>
              </div>
            </a>
          </div>
          <div className="bottomBox">
            <a
              href={blog.link}
              target="_blank"
              rel="noreferrer"
              style={{ color: "white" }}
            >
              <div>From The Blog</div>
              <h5>{blog.title}</h5>
            </a>
          </div>
        </div>
      </div>
    );
}
